import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  reports: [],
  currentReport: null,
  isFetching: false,
  error: false,
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    reportStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    reportSuccess: (state, action) => {
      state.isFetching = false;
      state.reports = action.payload;
    },
    reportFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    createReportStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    createReportSuccess: (state, action) => {
      state.isFetching = false;
      state.reports.push(action.payload);
    },
    createReportFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    updateReportStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    updateReportSuccess: (state, action) => {
      state.isFetching = false;

      const idx = state.reports.findIndex((r) => r._id === action.payload._id);
      if (idx >= 0) {
        state.reports[idx] = action.payload;
      }
    },
    updateReportFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    deleteReportStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    deleteReportSuccess: (state, action) => {
      state.isFetching = false;
      state.reports = state.reports.filter((r) => r._id !== action.payload);
    },
    deleteReportFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const {
  reportStart,
  reportSuccess,
  reportFailure,
  createReportStart,
  createReportSuccess,
  createReportFailure,
  updateReportStart,
  updateReportSuccess,
  updateReportFailure,
  deleteReportStart,
  deleteReportSuccess,
  deleteReportFailure,
} = reportSlice.actions;

export default reportSlice.reducer;